export default class FilterParameterDescription<Value extends string | string[]> {
	name: string;

	label: string;

	disabled: boolean;

	type: string;

	initialValue: Value;

	constructor(name: string, label: string, disabled: boolean, type: string, initialValue: Value) {
		this.name = name;
		this.label = label;
		this.disabled = disabled;
		this.type = type;
		this.initialValue = initialValue;
	}

	disabledUpdated(disabled: boolean): FilterParameterDescription<Value> {
		return new FilterParameterDescription(this.name, this.label, disabled, this.type, this.initialValue);
	}

	isDate(): boolean {
		return this.type === 'date';
	}

	parseValueFromString(value: string | string[], separator = ','): string | string[] | null {
		if (typeof this.initialValue === 'string') {
			return value;
		}

		if (this.initialValue instanceof Array) {
			return value === '' || typeof value !== 'string' ? [] : value.split(separator);
		}

		return null;
	}
}
